(function () {
  var cfg = window.__faviconAnim;
  if (!cfg || !cfg.video) return;

  document.querySelectorAll('link[rel~="icon"]').forEach(function (el) {
    el.parentNode.removeChild(el);
  });

  var link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  document.head.appendChild(link);

  if (cfg.fallback) {
    link.href = cfg.fallback;
  }

  var video = document.createElement('video');
  video.src = cfg.video;
  video.muted = true;
  video.defaultMuted = true;
  video.loop = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.width = 32;
  video.height = 32;
  video.style.cssText = 'position:fixed;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none';

  var canvas = document.createElement('canvas');
  canvas.width = 32;
  canvas.height = 32;
  var ctx = canvas.getContext('2d');
  var running = false;
  var last = 0;

  function frame(t) {
    if (!running) return;
    if (t - last > 66 && video.readyState >= 2) {
      last = t;
      ctx.drawImage(video, 0, 0, 32, 32);
      link.href = canvas.toDataURL('image/png');
    }
    requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  video.addEventListener('canplay', function () {
    video.play().catch(function () {});
    start();
  });

  document.documentElement.appendChild(video);
  video.play().catch(function () {});

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      running = false;
      video.pause();
    } else {
      video.play().catch(function () {});
      start();
    }
  });
})();
